import { Capacitor } from '@capacitor/core';

/**
 * Platform helpers for App Store compliance (MOJ-48).
 *
 * Apple Guideline 3.1.1 / 2.1(b): the iOS app must not expose any purchase
 * path — no Stripe checkout, no customer portal, no "Upgrade"/"Subscribe"
 * buttons, no upsell banners and no links to pricing pages. Trainers pay on
 * the web; the iOS app only shows read-only subscription status.
 *
 * Use `isIosApp()` to gate every such element. Web behaviour is unchanged.
 */
export const isIosApp = (): boolean => Capacitor.getPlatform() === 'ios';

/**
 * Header sent with every API request from the iOS app so the backend can
 * refuse purchase-path endpoints (`/billing/checkout`, `/billing/portal`)
 * even if a stale build still tried to call them. Mirrored in
 * backend/src/lib/clientPlatform.ts.
 */
export const PLATFORM_HEADER = 'X-Mojo-Platform';

/** Wording shown on iOS wherever the web app would link to billing. No link, no domain. */
export const IOS_BILLING_NOTE = 'Dein Abonnement wird auf der Website verwaltet.';
